import Box from '@mui/material/Box';
import { msgTypes } from 'constants/msgTypes';
import { AnnouncementModel } from 'model/screensModels/AnnouncementModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import React, { useState } from 'react';
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { AnnouncementService } from 'services/menu/announcementService/AnnouncementService';
import ApiUrl from 'services/shared/ApiUrl';
import { AnnouncementList } from './AnnouncementList';
import { CreateAnnouncement } from './CreateAnnouncement';


export const Announcement = () => {

  const [updateValue, setUpdateValue] = React.useState(new AnnouncementModel());
  const [flag, setFlag] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
  
  const [recentAnnouncements, setRecentAnnouncements] = useState(new AnnouncementModel());

  React.useEffect(()=>{
    loadRecentAnnouncement();
  },[])
  
  const getUpdateRecordValue = (announcementModel: AnnouncementModel) => {
    setIsEditMode(true);
    setUpdateValue(announcementModel);
  }

  const addAnnouncement = () => {
    setUpdateValue(new AnnouncementModel());
    setIsEditMode(false); // Reset edit mode
    setFlag(true)
  }

  //Prepare request body to get recent announcement
  const prepareRequest = async() => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;

    //get Company Id
    const userDetails = await LocalStorageService.getUserDetails();
    if (userDetails !== '') {
      const companyDetails = JSON.parse(userDetails)
      requestBody.companyId = companyDetails.companyId;
    }

    return requestBody;
  }

  //Get Announcements list
  const loadRecentAnnouncement = async () => {
    const requestBody = await prepareRequest();
    const res = await AnnouncementService.getAnnouncementList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if(res?.data!==''){
      setRecentAnnouncements(res?.data?.tbody[0]);
      }else{
        setRecentAnnouncements(new AnnouncementModel())
      }
    }
  }

  const RecentAnnouncements = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently added Announcement </h5>
        {recentAnnouncements.announcementId!=='' ? (
        <div>
          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Title : </h5>
            </div>
            <div className='col-lg-8'>
              {recentAnnouncements.title}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Description : </h5>
            </div>
            <div className='col-lg-8'>
              {recentAnnouncements.message}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Attachments : </h5>
            </div>
            <div className='col-lg-8'>
              <img src={ApiUrl.fileBaseUrl + recentAnnouncements.attachment} className="recentdded-section"></img>
            </div>
          </div>
        </div>
         ) :(
          <>
          <DataNotFound message="There is no Announcement"/>
          </>
         )}
      </>
    )
  }


  return (

    <Box sx={{ width: '100%' }} className="container container-h-full">
      <Box>
      
        <div className="content-subheader">
            {!flag ? (
              <h2 className="font-weight-bolder">Announcement List</h2>
            ) : (
              <h2 className="font-weight-bolder">{isEditMode ? 'Edit Announcement' : ' Create Announcement'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addAnnouncement}>Create Announcement</button>}
          </div>
      </Box>
     
        {flag ?
          (
              <div className='row'>
                <div className='col-lg-4 work '>
                  <div className='sub-content-sec recently-blog'>
                    <RecentAnnouncements />
                  </div>
                </div>
                <div className='col-lg-8'>
                  {/* <div className='sub-content-sec'> */}
                    <CreateAnnouncement setFlag={setFlag} updateRecord={updateValue} loadRecentAnnouncement={loadRecentAnnouncement}></CreateAnnouncement>
                  {/* </div> */}
                </div>
              </div>

          )
          : (
            <div className='sub-content-sec recently-blog'>
          <AnnouncementList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentAnnouncement={loadRecentAnnouncement}></AnnouncementList>
          </div>
          )
        }
     

    </Box>

  )
}
